import { render, staticRenderFns } from "./IndirectGateWayList.vue?vue&type=template&id=f64fb62a"
import script from "./IndirectGateWayList.vue?vue&type=script&lang=js"
export * from "./IndirectGateWayList.vue?vue&type=script&lang=js"
import style0 from "./IndirectGateWayList.vue?vue&type=style&index=0&id=f64fb62a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports